import {format_percentage} from '@bitstillery/common/lib/format'
import {MithrilComponent} from '@bitstillery/mithril'
import {$s} from '@bitstillery/common/app'
import {classes} from '@bitstillery/common/lib/utils'
import m from '@bitstillery/mithril'

interface MarginPercentageAttrs {
    className?: string
    label?: string
    value: string | number | null // Margin percentage as a fraction.
}

export class CellMargin extends MithrilComponent<MarginPercentageAttrs> {
    // Do NOT use hardcoded margin values; this is sensitive data.
    low_margin_range = 0
    start_target_margin_range = 0

    view(vnode: m.Vnode<MarginPercentageAttrs>): m.Children {
        const margin_percentage: number | null = vnode.attrs.value !== null ? Number(vnode.attrs.value) * 100 : null
        let color_class = 'rating-warning'
        if (margin_percentage !== null) {
            if (margin_percentage < $s.margin.low) {
                color_class = 'rating-danger'
            } else if (margin_percentage > $s.margin.target) {
                color_class = 'rating-success'
            }
        }

        return (
            <span className={classes('c-margin', vnode.attrs.className)}>
                {vnode.attrs.label && <label>{vnode.attrs.label}</label>}
                {margin_percentage !== null && (
                    <span className={classes('amount', color_class)}>
                        {format_percentage(margin_percentage / 100, $s.identity.user.decimal_locale)}
                    </span>
                )}
                {margin_percentage === null && <span>-</span>}
            </span>
        )
    }
}
